import React from "react";
import { useDispatch } from "react-redux";
import { loadingOrganisation } from "../../redux/actions";
import { Organisation } from "../../domain/Organisation";
import { AcceptedDialog } from "./dialogs/AcceptedDialog";
import { AddEventDialog } from "./dialogs/AddEventDialog";
import { ApprovalDialog } from "./dialogs/ApprovalDialog";
import { AttachDialog } from "./dialogs/AttachDialog";
import { MessageDialog } from "./dialogs/MessageDialog";
import { ProposedDialog } from "./dialogs/ProposedDialog";
import { RecordEventCompletionDialog } from "./dialogs/RecordEventCompletionDialog";
import { RejectedDialog } from "./dialogs/RejectedDialog";
import { UpdatedDialog } from "./dialogs/UpdatedDialog";
import { DialogType, EntityDialog } from "./types";
import { UpdatedApplicationDialog } from "./dialogs/UpdatedApplicationDialog";

type RenderDialogProps = {
  focussedEntity: EntityDialog | null;
  onClose: () => void;
  organisation: Organisation;
  isAdmin: boolean;
  isOfqualAdmin: boolean;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  organisation,
  isAdmin,
  isOfqualAdmin,
}) => {
  const dispatch = useDispatch();

  if (!focussedEntity) {
    return null;
  }

  const { dialogType } = focussedEntity;

  if (dialogType === DialogType.AddEvent) {
    return (
      <AddEventDialog
        organisation={organisation}
        onClose={onClose}
        isAdmin={isAdmin}
      ></AddEventDialog>
    );
  } else if (dialogType === DialogType.Approval) {
    return (
      <ApprovalDialog
        organisation={organisation}
        onClose={() => {
          dispatch(loadingOrganisation(organisation.itemId.toString()));
          onClose();
        }}
        isAdmin={isOfqualAdmin}
      />
    );
  } else if (dialogType === DialogType.SendMessage) {
    return <MessageDialog orgId={organisation!.id} onClose={onClose} />;
  } else if (dialogType === DialogType.AddAttachment) {
    return <AttachDialog orgId={organisation!.id} onClose={onClose} />;
  } else {
    const activity = focussedEntity.focussedActivity!;
    switch (activity.activityType) {
      case 2:
        return <UpdatedDialog activity={activity} onClose={onClose} />;
      case 49:
        return (
          <UpdatedApplicationDialog activity={activity} onClose={onClose} />
        );
      case 3:
        return <ProposedDialog activity={activity} onClose={onClose} />;
      case 4:
        return <AcceptedDialog activity={activity} onClose={onClose} />;
      case 5:
        return <RejectedDialog activity={activity} onClose={onClose} />;
      case 25:
        return (
          <RecordEventCompletionDialog
            engagementEvent={activity}
            onClose={onClose}
            organisation={organisation}
          />
        );
      default:
        return null;
    }
  }
};
